<template>
    <section>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>
                        <required /> Plano</label>
                    <select @change="changePlan()" v-model="empresa.plano.fk_plano_id" class="form-control">
                        <option :value="null">{{$t('words.select')}}</option>
                        <option v-for="item in planos" :key="item.id" :value="item.id">{{item.nome}} -
                            {{formatMoney(item.valor)}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>
                        <required /> Validade</label>
                    <select @change="changeDate()" v-model="empresa.plano.fk_validade_id" class="form-control">
                        <option :value="null">{{$t('words.select')}}</option>
                        <option v-for="item in validades" :key="item.id" :value="item.id">{{item.nome}} -
                            {{item.vencimento}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>
                        <required /> Valor</label>
                    <money :disabled="!mudarValor" v-model="empresa.plano.valor" class="form-control">
                    </money>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>
                        <required /> Data de Vencimento</label>
                    <input :disabled="!mudarVencimento" v-model="empresa.plano.vencimento_padrao" type="date"
                        class="form-control">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>
                        <required /> Recorrente?</label>
                    <select disabled v-model="empresa.plano.recorrente" class="form-control">
                        <option :value="1">{{$t('words.yes')}}</option>
                        <option :value="0">{{$t('words.no')}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <p-check v-model="mudarValor" class="p-switch p-fill" :color="appLayout.switch">
                        <strong>Modificar o valor do
                            plano?</strong></p-check>
                    <p><small>* Necessário validação do novo contrato com o cliente</small></p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <p-check v-model="mudarVencimento" class="p-switch p-fill" :color="appLayout.switch">
                        <strong>Modificar o vencimento
                            do plano?</strong></p-check>
                    <p><small>* Necessário validação do novo contrato com o cliente</small></p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            empresa: {},
            validades: {},
            planos: {},
        },
        data() {
            return {
                selectedPlano: null,
                mudarValor: false,
                mudarVencimento: false,
            }
        },
        computed: {
           
        },
        beforeMount() {
            
            
        },
        methods: {
            changePlan() {
                this.selectedPlano = this.planos.find(x => x.id == this.empresa.plano.fk_plano_id);
                this.selectedPlano.fk_validade_id = this.empresa.plano.fk_validade_id;
                this.selectedPlano.recorrente = this.empresa.plano.recorrente;
                if (this.selectedPlano) {
                    this.empresa.plano = _.cloneDeep(this.selectedPlano);
                    this.empresa.plano.fk_plano_id = this.selectedPlano.id;
                    this.calcPlan();
                } else {
                    this.empresa.plano.modulos = [];
                    this.empresa.plano.valor = 0;
                }
            },
            calcPlan() {
                if (!this.selectedPlano) {
                    return;
                }
                this.empresa.plano.valor = this.selectedPlano.valor;
                if (this.selectedDate) {
                    this.empresa.plano.valor = this.selectedPlano.valor * parseInt((this.selectedDate.vencimento / 30));
                    this.empresa.plano.valor -= ((this.selectedDate.desconto / 100) * this.empresa.plano.valor);
                    this.empresa.plano.vencimento_padrao = new Date(new Date().setDate(new Date().getDate() +
                            this.selectedDate.vencimento))
                        .toISOString()
                        .substring(0, 10)
                } else {
                    this.empresa.plano.vencimento_padrao = new Date(new Date().setDate(new Date().getDate() +
                            30))
                        .toISOString()
                        .substring(0, 10)
                }
            },
            changeDate() {
                this.selectedDate = this.validades.find(x => x.id === this.empresa.plano.fk_validade_id);
                this.calcPlan();
                this.addItens();
            },
            addItens() {
                this.empresa.adicionais = this.empresa.adicionais.filter(x => x.adicional == true);
                for (let p = 0; p < this.selectedPlano.modulos; p++) {
                    let pdv = {
                        adicional: false,
                        valor: 0,
                        vencimento: this.empresa.plano.vencimento_padrao,
                        fk_validade_id: this.empresa.plano.fk_validade_id,
                    }
                    if (this.selectedPlano[p].tipo == 'ADICIONAL') {
                        this.empresa.adicionais.push(pdv);
                    }
                }
            },
        }
    }
</script>